import { ImageName } from "@mcleod/images";
import { Cursor, Label, Panel } from "@mcleod/components";
import { Alignment, Navigation, StringUtil } from "@mcleod/core";

export class DistanceRateUtil {
    navigateTo(URL: string): void {
        Navigation.navigateTo(URL, { newTab: true });
    }

    addClickListenerToLabel(labelName: Label, vendorURL: any) {
        labelName.addClickListener(() => this.navigateTo(vendorURL));
    }

    createHoverToDiscover(vendorsData: any, label: Label) {
        const vendor_name = vendorsData?.vendor_name;
        const rateTypeDesc = vendorsData?.rate_type_desc;
        const vendor = vendorsData?.vendor;
        label.tooltipPosition = Alignment.BOTTOM;

        const panel = new Panel({ id: "panelHoverToDisplay", maxWidth: 400, cursor: Cursor.DEFAULT }) as Panel;
        const fuelSurchargeNote = vendorsData?.fuel_surcharge_note;
        const labelOne = new Label({ id: "hoverIdOne", fontBold: true, fontSize: "xlarge", text: `${vendorsData?.vendor_name} `, rowBreak: false });
        const labelTwo = new Label({ id: "hoverIdTwo", fontBold: true, text: "", rowBreak: true, imageName: ImageName.detail, color: "primary", tooltip: `Click to go to Vendor [${vendorsData?.vendor_name}] Website`, cursor: Cursor.POINTER });
        const labelThree = new Label({ id: "hoverIdThree", text: `Miles and tolls used in the rate calculation come from the upper right distance profile set in the Overview section of this screen.`, rowBreak: true });
        const labelFour = new Label({ id: "hoverIdFour", text: "Rate calculations use non-rounded numbers, but display as rounded numbers, potentially resulting in minor differences.", rowBreak: true });
        const labelFive = new Label({ id: "hoverIdFive", text: `Confidence rating: ${vendorsData?.confidence_rating} \n`, rowBreak: true });
        const labelSix = new Label({ id: "hoverIdSix", text: rateTypeDesc, rowBreak: true });

        panel.add(labelOne);
        if(!StringUtil.isEmptyString(vendorsData?.rate_url)) {
            this.addClickListenerToLabel(labelTwo, vendorsData?.rate_url);
            panel.add(labelTwo);
        }

        panel.add(labelThree);
        panel.add(labelFour);
        if(StringUtil.equalsIgnoreCase(vendor_name,"Greenscreens")){
            panel.add(labelFive);
        }
        panel.add(labelSix);

        if (!StringUtil.isEmptyString(fuelSurchargeNote)) {
            const labelDynamicA = new Label({ id: "hoverIdDynamicFuelSurcharge", text: fuelSurchargeNote, rowBreak: true });
            panel.add(labelDynamicA);
        }
        label.tooltipDynamicContent = panel;
    }

    populateValueTotalRateVendor(label: Label, vendorsData: any) {
        if (label.field === "total_rate_vendor" || label.field === "total_sell_rate") {
            label.text = vendorsData[label.field];
            label.color = "subtle.darkest";
            label.fontSize = "xxlarge";
        }
    }

    populateValueRatePerMile(label: Label, vendorsData: any) {
        if (label.field === "total_rate_per_mile") {
            label.text = "rpm / " + vendorsData[label.field];
            label.color = "subtle.dark";
            label.fontSize = "medium";
        }
    }
}
